<template>
    <div>
        <div ref="modal" 
            class="modal fade" 
            data-bs-backdrop="static" 
            tabindex="-1" 
            aria-labelledby="erkModalLabel" 
            aria-modal="true" 
            role="dialog" 
            style="padding-right: 17px;">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header py-2 pe-2">
                        <strong class="modal-title" id="erkModalLabel">SALVA IN...</strong>
                        <a href="#" title="" data-bs-dismiss="modal" aria-label="Chiudi">
                            <i class="bi bi-x-circle"></i>
                        </a>
                    </div>
                    <div class="modal-body">
                        <div v-if="isLoading" class="message">
                            Caricamento...
                        </div>
                        <div v-else>
                            <div v-if="!paths || paths.length == 0" class="message">
                                Nessun percorso trovato
                            </div>
                            <div v-else>
                                <div
                                    v-for="(path, pk) in paths" :key="pk"
                                    class="row g-lg-3 mb-3">
                                    <div>
                                        <div class="form-check">
                                            <input type="checkbox" name="selectedPaths" class="form-check-input" 
                                                v-model="selectedPaths"
                                                :value="path.content_id">
                                            <label class="form-check-label" for="checkFilter1">
                                                {{path.name}}                
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Campo per inserimento nuovo percorso (con link/button per attivazione) -->
                            <div class="row">
                                <div class="col-10">
                                    <input class="form-control form-control-sm " 
                                        :value="newPathName" 
                                        @input="newPathName = $event.target.value"
                                        placeholder="Nome nuovo percorso">
                                </div>
                                <div class="col-2">
                                    <button class="btn btn-primary"
                                        :disabled="newPathName.length == 0"
                                        @click="onClickAdd()">
                                        <i class="bi bi-clipboard-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!-- CTA -->
                        <button type="button" class="btn btn-primary close-btn"
                            :disabled="selectedPaths.length == 0"
                            @click="onClickSave()"
                            >
                            <span class="bi-check2-circle"></span>
                            Salva
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"

let modal = null

export default{
    props: {
    },
    data(){
        return {
            isLoading: false,
            newPathName: '',
            paths: [],
            selectedPaths: [],
            content: {},
            userId: 0
        }
    },
    created(){

    },
    methods: {
        open(content, userId){
            modal = new window.bootstrap.Modal( this.$refs.modal )
            modal.show()  

            this.content = content
            this.userId = userId
            this.loadData()
        },
        loadData(){
            this.isLoading = true

            axios.post('/structure/content/ContentPathAction-findAllPrivateForUser', {
                contentId: this.content.content_id
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }

                    this.selectedPaths = response.data.data.selected
                    this.paths = response.data.data.paths
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        onClickAdd(){
            this.isLoading = true
            axios.post("/structure/content/ContentPathAction-addPrivatePath", {
                pathName: this.newPathName
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }

                    this.newPathName = ''
                    this.loadData()
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        onClickSave(){
            this.isLoading = true
            axios.post("/structure/content/ContentPathAction-addContentToPath", {
                contentId: this.content.content_id,
                pathsIds: this.selectedPaths
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }

                    this.newPathName = ''
                    modal.hide()  
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        }
    }
}

</script>
<style scoped>
.message{
    text-align: center;
    padding: 30px;
}
</style>